import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateProductRequest, Product, UpdateProductRequest } from '@models/product.model';
import { environment } from '@environment/environment';

@Injectable({providedIn: 'root'})
export class ProductService {
  private readonly http = inject(HttpClient);
  private readonly ENDPOINT = 'products';

  getAll(webshopId: string): Observable<Product[]> {
    return this.http.get<Product[]>(`${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}`);
  }

  create(webshopId: string, product: CreateProductRequest): Observable<Product> {
    return this.http.post<Product>(`${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}`, product);
  }

  update(webshopId: string, product: Partial<UpdateProductRequest> & { id: string }): Observable<Product> {
    return this.http.patch<Product>(`${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}/${product.id}`, product);
  }

  delete(webshopId: string, productId: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}/${productId}`);
  }
}
